import(/* webpackMode: "eager" */ "/var/lib/jenkins/workspace/Homework_web_test/next-bee-website/src/app/global-error.tsx");
